var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, matchPath } from 'react-router-dom';
import Header from '../Header';
import AdminPageContainer from '../admin_page_container';
import JoinPage from '../join_page';
import HomePage from '../HomePage';
import PageNotFound from '../page_not_found';
import RedirectTo from '../RedirectTo';
import { getIsAdmin, getIsPendingMember, getTeamName, getTeamId, } from '../../selectors/portal_selector';
import { getFirstAdminTeamAccountId, getSelectedTeamAccount, getFirstTeamAccountIdFromMultiPortalSelectorOptions, } from '../../selectors/uiSelector';
import { ADMIN_SUBPAGES } from '../../utils/admin_helper';
import { PORTAL_ROUTE_PREFIX, HOME_PAGE_PATH } from '../../constants/values';
export var isOnJoinPage = function (pathname) {
    return matchPath(pathname, {
        path: PORTAL_ROUTE_PREFIX + "/join",
        exact: true,
        strict: false,
    });
};
var PortalRouter = function (props) {
    var shouldRedirectToJoinPage = props.isPendingMember && !isOnJoinPage(props.history.location.pathname);
    if (shouldRedirectToJoinPage) {
        return React.createElement(Redirect, { to: PORTAL_ROUTE_PREFIX + "/join" });
    }
    var allowAdminSettingsPage = Boolean(props.isAdmin && props.firstAdminTeamAccountId);
    var firstAdminTeamAccountId = props.firstAdminTeamAccountId ||
        props.selectedTeamAccount ||
        props.firstTeamAccountIdFromMultiPortalSelectorOptions;
    return (React.createElement("div", null,
        !isOnJoinPage(props.history.location.pathname) && (React.createElement(Route, { path: "" + PORTAL_ROUTE_PREFIX, render: function (routeProps) { return React.createElement(Header, __assign({}, routeProps, props)); } })),
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/", render: function () {
                    return React.createElement(Redirect, { to: "" + PORTAL_ROUTE_PREFIX });
                } }),
            React.createElement(Route, { exact: true, path: "" + PORTAL_ROUTE_PREFIX, render: function () {
                    return React.createElement(Redirect, { to: HOME_PAGE_PATH });
                } }),
            React.createElement(Route, { exact: true, path: HOME_PAGE_PATH, render: function () { return React.createElement(HomePage, { isAdmin: props.isAdmin }); } }),
            React.createElement(Route, { exact: true, path: PORTAL_ROUTE_PREFIX + "/admin", render: function () {
                    if (allowAdminSettingsPage) {
                        var redirectPath = PORTAL_ROUTE_PREFIX + "/admin/" + firstAdminTeamAccountId + "/members";
                        return React.createElement(Redirect, { to: redirectPath });
                    }
                    return React.createElement(Redirect, { to: "" + PORTAL_ROUTE_PREFIX });
                } }),
            React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/:subpage?", render: function (routeProps) {
                    if (allowAdminSettingsPage) {
                        if (ADMIN_SUBPAGES.has(routeProps.match.params.subpage)) {
                            return React.createElement(AdminPageContainer, __assign({}, props, routeProps));
                        }
                        return React.createElement(PageNotFound, null);
                    }
                    return React.createElement(Redirect, { to: "" + PORTAL_ROUTE_PREFIX });
                } }),
            React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/join", render: function () { return React.createElement(JoinPage, null); } }),
            React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/redirect-to", render: function (routeProps) {
                    var _a, _b;
                    return (React.createElement(RedirectTo, __assign({}, routeProps, props, { matchedPath: (_a = routeProps === null || routeProps === void 0 ? void 0 : routeProps.match) === null || _a === void 0 ? void 0 : _a.path, pathname: (_b = routeProps === null || routeProps === void 0 ? void 0 : routeProps.location) === null || _b === void 0 ? void 0 : _b.pathname })));
                } }),
            React.createElement(Route, { component: PageNotFound }))));
};
var mapStateToProps = function (state) { return ({
    isAdmin: getIsAdmin(state),
    isPendingMember: getIsPendingMember(state),
    teamName: getTeamName(state),
    firstAdminTeamAccountId: getFirstAdminTeamAccountId(state),
    selectedTeamAccount: getSelectedTeamAccount(state),
    firstTeamAccountIdFromMultiPortalSelectorOptions: getFirstTeamAccountIdFromMultiPortalSelectorOptions(state),
    teamId: getTeamId(state),
}); };
export default connect(mapStateToProps, null)(PortalRouter);
